<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active">
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          <router-link to="/couponMaster">Coupons</router-link>
        </li>
      </ol>
      <div class="row">
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search"
                v-model="searchText"
              />
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              v-on:click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Search
            </button>
          </div>
        </div>
        <!-- <div class="col-md-3">
          <div class="user-buttonall">
            <ul>
              <li>
                <div class="form-group">
                  <label>Upload Part Serial number</label>
                  <input
                    type="file"
                    v-on:change="handleFileUpload()"
                    id="inputFile4"
                    multiple=""
                    ref="file"
                    name="reborer"
                  />
                  <div class="input-group">
                    <input
                      type="text"
                      readonly=""
                      id="addon3"
                      class="form-control"
                      placeholder="CSV File"
                    />
                    <span class="input-group-btn input-group-sm">
                      <button type="button" class="btn btn-fab btn-fab-mini">
                        <i class="material-icons">attach_file</i>
                      </button>
                    </span>
                  </div>
                  <div v-if="message" class="alert-success" role="alert">
                    {{ message }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="col-md-3" v-if="$can('Create', 'Loyalty::Coupons')">
          <div class="user-buttonall">
            <ul>
              <li>
                <div class="form-group">
                  <router-link to="/generateCoupons"
                    >Generate Coupons</router-link
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button type="button" @click="filterTotalCoupon" class="btn btn-default" v-bind:class="{'active':(FilterSetOnClick=='')}">
            Total Coupons <span class="badge"> {{ TotalCoupon }}</span>
          </button>
          <button type="button" @click="filterAvaialable" class="btn btn-default" v-bind:class="{'active':(FilterSetOnClick=='Available')}">
            Marry Coupons <span class="badge"> {{ AvailableCoupon }}</span>
          </button>
          <button type="button" @click="filterNewGenerated" class="btn btn-default" v-bind:class="{'active':(FilterSetOnClick=='NewGenerate')}">
            New Generated Coupons
            <span class="badge"> {{ GeneratedCoupon }}</span>
          </button>
        </div>
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading">
              <div class="panel-ctrls"></div>
            </div>
            <div class="panel-body no-padding visibility">
              <table
                class="table table-striped table-bordered"
                cellspacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <th>Points</th>
                    <th>Status</th>
                    <th>Expire Date</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in coupon_data"
                    :key="item.id"
                    class="gradeC"
                  >
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td class="left-align">
                      <!-- <router-link
                        :to="{
                          name: 'editReborer',
                          params: { partner_id: item.id },
                        }"
                        ></router-link
                      > -->
                      {{ item.coupon }}
                    </td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.status }}</td>
                    <td>{{ item.expire_date | dateFormatReadable }}</td>
                    <td>
                      {{
                        item.modified_date
                          ? item.modified_date
                          : item.created_date | dateFormatReadable
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!--end table-->
            </div>
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div id="externalScript"></div> -->
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import moment from 'moment';
export default {
  name: 'couponMaster',
  data() {
    return {
      coupon_data: [],
      searchText: '',
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      message: '',
      AvailableCoupon: 0,
      GeneratedCoupon: 0,
      TotalCoupon: 0,
      FilterSetOnClick: '',
    };
  },
  components: {
    Paginate,
  },
  methods: {
    filterTotalCoupon() {
      this.FilterSetOnClick = '';
      this.getAllCoupons(1);
    },
    filterNewGenerated() {
      this.FilterSetOnClick = 'NewGenerate';
      this.getAllCoupons(1);
    },
    filterAvaialable() {
      this.FilterSetOnClick = 'Available';
      this.getAllCoupons(1);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (this.FilterSetOnClick) {
        params['FilterSetOnClick'] = this.FilterSetOnClick;
      }

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getAllCoupons(pageNum) {
      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/Coupon/list', params)
        .then((response) => {
          const {
            coupon_data,
            totalItems,
            currentPage,
            TotalPage,
            AvailableCoupon,
            GeneratedCoupon,
            TotalCoupon,
          } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon = AvailableCoupon;
          this.GeneratedCoupon = GeneratedCoupon;
          this.TotalCoupon = TotalCoupon;
        })
        .catch((e) => {
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
      this.skyloEnd();
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },
    handleFileUpload() {
      this.uploadFile = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      let loader = this.$loading.show();
      let formData = new FormData();
      formData.append('ProductSerails', this.uploadFile);
      commonServices
        .post_upload_file('kspgAPI/Coupon/upload', formData)
        .then(
          (responce) => {
            this.message = responce.data.message;
            if (responce.data.status) {
            }
          },
          (error) => {
            //   this.loading = false;
            this.message =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          this.errors.push(e);
          if (e.response.data.error == 'Invalid API key ') {
            loader.hide();
            this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => {
        loader.hide();
      }, 1000);
    },
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
.search-button {
  background-color: #555555;
  color: #ffffff;
}
.left-align {
  text-align: left !important;
}
</style>
